import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-maps-modal',
  templateUrl: './maps-modal.component.html',
  styleUrls: ['./maps-modal.component.scss']
})
export class MapsModalComponent {
  @Input() public latitude: number;
  @Input() public longitude: number;
  @Input() public zoom: number;
  @Input() public mapTitle: string;

  @Input() public address: string;

  constructor(public activeModal: NgbActiveModal,
    private readonly cdr: ChangeDetectorRef) {
  }

  dismiss(): void {
    this.activeModal.dismiss();
  }

  close(): void {
    this.activeModal.close({ address: this.address, lat: this.latitude, lng: this.longitude });
  }

  public onUpdateCoordinates(coordinates: any): void {
    this.longitude = coordinates.longitude;
    this.latitude = coordinates.latitude;
    this.address = coordinates.address;

    this.cdr.detectChanges();
  }
}